<template>
  <v-dialog v-model="newLeadModalVisible" max-width="700px" @keydown.enter="addItem" class="ma-0 pa-0">
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card class="ma-0 pa-0">
      <v-container grid-list-md class="pt-2 pb-0 add-product-container">
        <v-row wrap class="">
          <v-col cols="12" class="mt-3">
            <span class="headline">Lisää liidin tiedot</span>
          </v-col>
          <v-col cols="3" class="pt-2">
            <v-text-field 
              v-model="newLead.companyName" 
              label="Yrityksen nimi*" 
              :error-messages="errors.companyName"
              @keyup="v => v !== '' ?  errors.companyName = '' :  ''"
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="3" class="pt-2">
            <v-text-field 
              v-model="newLead.companyId" 
              label="Y-tunnus" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="3" class="pt-2">
            <v-text-field 
              v-model="newLead.industryCode" 
              label="Toimialakoodi" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="3" class="pt-2">
            <v-text-field 
              v-model="newLead.industryCodeName" 
              label="Toimialan nimi" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" class="pt-2">
            <v-text-field 
              v-model="newLead.deliveryAddress" 
              label="Toimitusosoite*"
              :error-messages="errors.deliveryAddress" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="2" class="pt-2">
            <v-text-field 
              v-model="newLead.deliveryPostalCode" 
              label="Postikoodi*"
              :error-messages="errors.deliveryPostalCode" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="2" class="pt-2">
            <v-text-field 
              v-model="newLead.deliveryCity" 
              label="Toimipaikka*"
              :error-messages="errors.deliveryCity" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="2" class="pt-2">
            <v-text-field 
              v-model="newLead.deliveryCountry" 
              label="Maa*"
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          
          <!-- <v-col cols="12" class="pt-2 mt-3" style="border-top:1px solid #ccc;">
            <span class="headline">Lisää kontaktin tiedot</span>
          </v-col> -->
          <v-col cols="6" class="pt-2 pr-6">
            <v-text-field 
              v-model="newLead.firstName" 
              label="Etunimi" 
              required
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" class="pt-2">
            <v-text-field 
              v-model="newLead.lastName" 
              label="Sukunimi" 
              required
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" class="pt-2 pr-6">
            <v-text-field 
              v-model="newLead.contactPhone" 
              label="Puhelinnumero" 
              required
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" class="pt-2">
            <v-text-field 
              v-model="newLead.contactEmail" 
              label="Sähköpostiosoite" 
              required
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" class="pt-2">
            <v-text-field 
              v-model="newLead.contactRole" 
              label="Rooli" 
              required
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" class="pt-2">
            <v-text-field 
              v-model="newLead.productInterest" 
              label="Tuotekiinnostus" 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="12" class="pt-2">
            <v-textarea 
              single-line 
              rows=2
              :auto-grow="true" 
              v-model="newLead.message" 
              dense 
              label="Kontaktin lisätiedot" 
              hide-details>
            </v-textarea>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <v-btn color="avecor-button-global add-button mb-2 mr-1" outlined small @click="close">Peruuta</v-btn>
        <v-btn color="avecor-button-global add-button mb-2" outlined small @click="addItem" >Lisää</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import firebase from 'firebase'
var db = null

export default {
    props:[],
    data: () => ({
      autogrow:true,
      editedIndex: -1,
      newLead: {
        companyName:'',
        companyId:'',
        companyForm:'',
        deliveryAddress:'',
        deliveryPostalCode:'',
        deliveryCity:'',
        deliveryCountry:'Finland',
        website:'',
        firstName: "",
        lastName: "", 
        contactPhone: '',
        contactEmail: '',
        contactRole:'',
        companyRegistrationDate:'',
        industryCode:'',
        industryCodeName:'',
        vainuLink:'',
        staffNumber:'',
        revenue:'',
        message:'',
        productInterest:'',
        products:[],
        source:'',
        manuallyAdded:true,
        salesStatus:"not_contacted",
        preparationStatus:"ready_for_contact"
      },
      defaultLead: {
        companyName:'',
        companyId:'',
        companyForm:'',
        deliveryAddress:'',
        deliveryPostalCode:'',
        deliveryCity:'',
        deliveryCountry:'Finland',
        website:'',
        firstName: "",
        lastName: "", 
        contactPhone: '',
        contactEmail: '',
        contactRole:'',
        companyRegistrationDate:'',
        industryCode:'',
        industryCodeName:'',
        vainuLink:'',
        staffNumber:'',
        revenue:'',
        message:'',
        productInterest:'',
        products:[],
        source:'',
        manuallyAdded:true,
        salesStatus:"not_contacted",
        preparationStatus:"ready_for_contact"
      },
      errors: {
        companyName:'',
        companyId:'',
        companyForm:'',
        deliveryAddress:'',
        deliveryPostalCode:'',
        deliveryCity:'',
        deliveryCountry:'',
        website:'',
        firstName: "",
        lastName: "", 
        contactPhone: '',
        contactEmail: '',
        contactRole:'',
        companyRegistrationDate:'',
        industryCode:'',
        industryCodeName:'',
        vainuLink:'',
        staffNumber:'',
        revenue:'',
        message:'',
        productInterest:'',
      }
       
    }),
    watch: {
      
    },
    mounted() {
      db = firebase.firestore();
    },

    computed: {
      getSalespersons(){
        var staff = this.staff
        var salespersons = []
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if(s.role === 'sales' || s.role === 'ceo' || s.id ==='RqjgIwdXWzXqCR2MOVr1etp2iY22') salespersons.push({text:s.firstName, id:s.id})
          return {...s}
        })
        return salespersons
      },
      
      ...mapFields({
        settings:"settings",
        staff:"staff.staff",
        user:'user',
        newLeadModalVisible:"modals.additionalSales.newLead.visible",
      })
    },
    created () {},
    methods: {
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      close () {
        this.newLeadModalVisible = false
        setTimeout(() => {
          this.newLead = Object.assign({}, this.defaultCompany)
          this.editedIndex = -1
        }, 300)
      },
      async addItem () {
        if(this.staff[this.user.uid] && this.staff[this.user.uid].role === 'sales') {
          this.newLead.salesperson = this.user.uid
        }
        var errors = false
        if(this.newLead.companyName.trim() === '') {this.errors.companyName = "Yrityksen nimi lisättävä"; errors = true;}
        if(this.newLead.deliveryPostalCode.trim() === '') {this.errors.deliveryPostalCode = "Postikoodi lisättävä"; errors = true;}
        if(errors) return
        
        const leadRef = db.collection('leads').doc()
        const leadId = leadRef.id
        leadRef.set({
          id:leadId,
          ...this.newLead  
        })
        .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Lisätty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        this.close()
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/AddLead.vue